import React from "react"
import styled from "styled-components"
import { MARKS, BLOCKS, INLINES } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import { TYPE } from "../../../theme/styles/globals"
import Button from "../atoms/input/button"

const TextField = ({ mode, json, transition }) => {

    const options = {
        renderNode: {
            [MARKS.BOLD]: (_, children) => <BOLD>{children}</BOLD>,
            [BLOCKS.PARAGRAPH]: (_, children) => <P>{children}</P>,
            [BLOCKS.HEADING_2]: (_, children) => <H2>{children}</H2>,
            [BLOCKS.HEADING_3]: (_, children) => <H3>{children}</H3>,
            [BLOCKS.HEADING_4]: (_, children) => <H4>{children}</H4>,
            [INLINES.EMBEDDED_ENTRY]: (node) => {
                if(node.data.target.sys.contentType.sys.id === "button"){
                    return <Button 
                                mode={mode} 
                                label={node.data.target.fields.label['en-AU']} 
                                action={node.data.target.fields.action['en-AU']} 
                                link={node.data.target.fields.link['en-AU']} 
                                transition={transition}
                            />
                }
            },
        }
    }

    return(
        <Container>
            { documentToReactComponents(json, options) }
        </Container>
    )
}

export default TextField

const Container = styled.div`
    font-family:${TYPE.SERIF_FONT};
`

const BOLD = styled.span`
    font-family:${TYPE.SERIF_BOLD_FONT};
`

const P = styled.div`
    margin-bottom:30px;
    line-height:24px;
`

const H2 = styled.h2`
    font-family:${TYPE.SERIF_BOLD_FONT};
    font-size:48px;
    line-height:48px;
    margin-bottom:30px;
    font-weight:normal;
`

const H3 = styled.h3`
    font-family:${TYPE.SERIF_BOLD_FONT};
    font-size:36px;
    line-height:42px;
    margin-bottom:30px;
    font-weight:normal;
`

const H4 = styled.h4`
    font-family:${TYPE.SERIF_BOLD_FONT};
    font-size:24px;
    line-height:24px;
    margin-bottom:30px;
    font-weight:normal;
`